export default "__VITE_ASSET__B$0$zvsg__"